/** Local links can be provided as #my-section */
export const LOCAL_LINK_REGEXP: RegExp = /^\#[a-zA-Z0-9\-]+$/;

export const navigateToLink = (link: string): void => {
    if (!LOCAL_LINK_REGEXP.test(link)) {
        window.open(link, '_self');
        return;
    }

    // used here getElementById instead of querySelector
    // because selectors which start with a number ('#1', '#77' etc)
    // are not valid and require some special handling
    const el: HTMLElement | null = document.getElementById(link.replace('#', ''));
    if (el) {
        el.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
};
